import textingService from '@/modules/texting/services/textingService';

const state = {
  textingSettings: null,
  activeDedicatedNumber: null,
  isLoading: false,
};

const getters = {
  textingSettings: (state) => state.textingSettings,
  activeDedicatedNumber: (state) => state.activeDedicatedNumber,
  isLoading: (state) => state.isLoading,
};

const mutations = {
  setTextingSettings(state, settings) {
    state.textingSettings = settings;
  },
  setActiveDedicatedNumber(state, activeDedicatedNumber) {
    state.activeDedicatedNumber = activeDedicatedNumber;
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

const actions = {
  // currenty country code is hardcoded to US, but we should make it dynamic
  async getAvailablePhoneNumbers(context, countryCode = 'US') {
    const response = await textingService.getAvailablePhoneNumbers(countryCode);
    return response.data.available_phone_numbers;
  },

  async claimPhoneNumber({ commit }, { phoneNumber, countryCode = 'US', verificationRequestData = null }) {
    const response = await textingService.claimPhoneNumber(phoneNumber, countryCode, verificationRequestData);

    // Update the active dedicated number with the claimed number
    const activeDedicatedNumber = {
      phone_number: phoneNumber,
      country_code: countryCode,
      features: ['SMS'],
    };

    commit('setActiveDedicatedNumber', activeDedicatedNumber);

    // Also update texting settings
    const textingSettings = {
      dedicated_number: phoneNumber,
      texting_enabled: true,
      app_status: 'active',
    };

    commit('setTextingSettings', textingSettings);

    return response;
  },

  async fetchActiveDedicatedNumber({ commit }, params) {
    try {
      const activeDedicatedNumber = await textingService.getActiveTextingPhoneNumber(params);
      commit('setActiveDedicatedNumber', activeDedicatedNumber);
      return activeDedicatedNumber;
    } catch (error) {
      console.error('Error fetching active texting phone number:', error);
      return null;
    }
  },

  async fetchTextingSettings({ commit, dispatch }) {
    commit('setIsLoading', true);
    try {
      // Fetch the active dedicated number
      const activeDedicatedNumber = await dispatch('fetchActiveDedicatedNumber');

      // Create basic settings from the dedicated number info
      let settings = null;
      if (activeDedicatedNumber) {
        settings = {
          dedicated_number: activeDedicatedNumber.phone_number,
          texting_enabled: activeDedicatedNumber.features.includes('SMS'),
          app_status: 'active',
        };
      }

      commit('setTextingSettings', settings);
      return settings;
    } catch (error) {
      console.error('Error fetching texting settings:', error);
      return null;
    } finally {
      commit('setIsLoading', false);
    }
  },

  async setTextingStatus({ commit, state }, status) {
    const { activeDedicatedNumber } = state;
    if (activeDedicatedNumber) {
      const updatedNumber = { ...activeDedicatedNumber, status };
      commit('setActiveDedicatedNumber', updatedNumber);
    }
  },

  setIsLoading({ commit }, isLoading) {
    commit('setIsLoading', isLoading);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
